import React from "react";

import styles from "./Divider.module.css";

type DividerProps = {
	label: string;
};

export const Divider = ({ label }: DividerProps) => {
	return <div className={styles.root}>{label}</div>;
};
